<template>
  <v-item-group v-model="colorIndex" class="pt-4" mandatory>
    <v-row dense>
      <v-col v-for="color of colors" :key="color" md="2" cols="4">
        <v-item v-slot="{ active, toggle }">
          <v-card
            :color="color"
            class="d-flex justify-center align-center rounded-lg"
            height="40px"
            @click="toggle"
          >
            <v-icon v-show="active" color="white" large>mdi-check</v-icon>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    colors: {
      type: Array,
      default: () => [
        "#607D8B",
        "#F44336",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#03A9F4",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
      ],
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      colorIndex: this.colors.indexOf(this.value),
    };
  },
  watch: {
    value(newValue) {
      this.colorIndex = this.colors.indexOf(newValue);
    },
    colorIndex(newValue) {
      this.$emit("input", this.colors[newValue]);
    },
  },
};
</script>
